import { render, staticRenderFns } from "./students.vue?vue&type=template&id=d3555b66&scoped=true&"
import script from "./students.vue?vue&type=script&lang=js&"
export * from "./students.vue?vue&type=script&lang=js&"
import style0 from "./students.vue?vue&type=style&index=0&id=d3555b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3555b66",
  null
  
)

export default component.exports